function dissectSgtin(sgtin: string): string {
	let lastFive = sgtin.slice(-5);
	//6009880037.010.130087236368
	let hundredThousandDigit = sgtin[13];
	return (hundredThousandDigit + lastFive).replace(/^0+/, ""); //remove leading 0s
}

export { dissectSgtin };